package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.RoomRawQuery
import androidx.room3.coroutines.createFlow
import androidx.room3.paging.PagingSourceDaoReturnTypeConverter
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.xtream.data_kmp.FavoriteLiveStreamEntity
import com.xtream.data_kmp.dto.LiveStream
import kotlin.Boolean
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class LiveFavDao_Impl(
  __db: RoomDatabase,
) : LiveFavDao() {
  private val __db: RoomDatabase

  private val __insertAdapterOfFavoriteLiveStreamEntity:
      EntityInsertAdapter<FavoriteLiveStreamEntity>

  private val __deleteAdapterOfFavoriteLiveStreamEntity:
      EntityDeleteOrUpdateAdapter<FavoriteLiveStreamEntity>

  private val __pagingSourceDaoReturnTypeConverter: PagingSourceDaoReturnTypeConverter =
      PagingSourceDaoReturnTypeConverter()
  init {
    this.__db = __db
    this.__insertAdapterOfFavoriteLiveStreamEntity = object : EntityInsertAdapter<FavoriteLiveStreamEntity>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `liveFavoritesTable` (`streamId`,`sortOrder`) VALUES (?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: FavoriteLiveStreamEntity) {
        statement.bindLong(1, entity.streamId.toLong())
        statement.bindLong(2, entity.sortOrder)
      }
    }
    this.__deleteAdapterOfFavoriteLiveStreamEntity = object : EntityDeleteOrUpdateAdapter<FavoriteLiveStreamEntity>() {
      protected override fun createQuery(): String = "DELETE FROM `liveFavoritesTable` WHERE `streamId` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: FavoriteLiveStreamEntity) {
        statement.bindLong(1, entity.streamId.toLong())
      }
    }
  }

  public override suspend fun insert(item: FavoriteLiveStreamEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfFavoriteLiveStreamEntity.insert(_connection, item)
  }

  public override suspend fun insert(items: List<FavoriteLiveStreamEntity>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfFavoriteLiveStreamEntity.insert(_connection, items)
  }

  public override suspend fun delete(item: FavoriteLiveStreamEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfFavoriteLiveStreamEntity.handle(_connection, item)
  }

  public override suspend fun delete(items: List<FavoriteLiveStreamEntity>): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfFavoriteLiveStreamEntity.handleMultiple(_connection, items)
  }

  public override fun allAsFlow(): Flow<List<FavoriteLiveStreamEntity>> {
    val _sql: String = "SELECT * FROM liveFavoritesTable"
    return createFlow(__db, false, arrayOf("liveFavoritesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfSortOrder: Int = getColumnIndexOrThrow(_stmt, "sortOrder")
        val _result: MutableList<FavoriteLiveStreamEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: FavoriteLiveStreamEntity
          _item = FavoriteLiveStreamEntity()
          _item.streamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          _item.sortOrder = _stmt.getLong(_columnIndexOfSortOrder)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsPagingSource(): PagingSource<Int, FavoriteLiveStreamEntity> {
    val _sql: String = "SELECT * FROM liveFavoritesTable "
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("liveFavoritesTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<FavoriteLiveStreamEntity>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfSortOrder: Int = getColumnIndexOrThrow(_stmt, "sortOrder")
          val _result: MutableList<FavoriteLiveStreamEntity> = mutableListOf()
          while (_stmt.step()) {
            val _item: FavoriteLiveStreamEntity
            _item = FavoriteLiveStreamEntity()
            _item.streamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            _item.sortOrder = _stmt.getLong(_columnIndexOfSortOrder)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun hasEntity(id: Int): Boolean {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM liveFavoritesTable WHERE streamId = ?)"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, id.toLong())
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun hasEntityAsFlow(id: Int?): Flow<Boolean> {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM liveFavoritesTable WHERE streamId = ?)"
    return createFlow(__db, false, arrayOf("liveFavoritesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (id == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, id.toLong())
        }
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(): Long? {
    val _sql: String = "SELECT COUNT(*) FROM liveFavoritesTable"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getByOffset(offset: Int): LiveStream? {
    val _sql: String = "SELECT liveStreamsTable.*, liveFavoritesTable.sortOrder AS  'num' FROM liveStreamsTable INNER JOIN liveFavoritesTable ON liveStreamsTable.streamId = liveFavoritesTable.streamId ORDER BY liveFavoritesTable.sortOrder ASC LIMIT 1 OFFSET ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, offset.toLong())
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfEpgChannelId: Int = getColumnIndexOrThrow(_stmt, "epgChannelId")
        val _columnIndexOfTvArchive: Int = getColumnIndexOrThrow(_stmt, "tvArchive")
        val _columnIndexOfTvArchiveDuration: Int = getColumnIndexOrThrow(_stmt, "tvArchiveDuration")
        val _result: LiveStream?
        if (_stmt.step()) {
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpEpgChannelId: String?
          if (_stmt.isNull(_columnIndexOfEpgChannelId)) {
            _tmpEpgChannelId = null
          } else {
            _tmpEpgChannelId = _stmt.getText(_columnIndexOfEpgChannelId)
          }
          val _tmpTvArchive: Int?
          if (_stmt.isNull(_columnIndexOfTvArchive)) {
            _tmpTvArchive = null
          } else {
            _tmpTvArchive = _stmt.getLong(_columnIndexOfTvArchive).toInt()
          }
          val _tmpTvArchiveDuration: Int?
          if (_stmt.isNull(_columnIndexOfTvArchiveDuration)) {
            _tmpTvArchiveDuration = null
          } else {
            _tmpTvArchiveDuration = _stmt.getLong(_columnIndexOfTvArchiveDuration).toInt()
          }
          _result = LiveStream(_tmpStreamId,_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamType,_tmpEpgChannelId,_tmpTvArchive,_tmpTvArchiveDuration)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun sizeInTvChannelsTable(): Long? {
    val _sql: String = """
        |
        |        SELECT COUNT(*)
        |        FROM liveStreamsTable
        |        WHERE streamId IN (SELECT liveFavoritesTable.streamId FROM liveFavoritesTable)
        |    
        """.trimMargin()
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM liveFavoritesTable"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
